import axios from 'axios'
import {
	MessageBox,
	Message
} from 'element-ui'
// import store from '@/store'
import Cookies from 'js-cookie'
import {
	getToken,
	setToken,
	getItem,
	removeToken
} from '@/utils/auth'

// let baseUrl = 'https://rest.concoai.com'
// let baseUrl = 'https://restTest.concoai.com'
// let baseUrl = '/api'
let baseUrl = config.url

// create an axios instance
const service = axios.create({
	baseURL: baseUrl, // url = base url + request url
	timeout: 50000, // request timeout
})

// request interceptor
service.interceptors.request.use(
	config => {
		// do something before request is sent
		// if (store.getters.token) {
		//   // let each request carry token
		//   // ['X-Token'] is a custom headers key
		//   // please modify it according to the actual situation
		//   config.headers['X-Token'] = getToken()
		// }
		if (getItem('token1')) {
			config.headers['Authorization'] = 'Bearer ' + getItem('token1')
		}
		// config.headers['Authorization'] = 'Bearer ' + 'eyJhbGciOiJIUzUxMiJ9.eyJyYW5kb21LZXkiOiI1Iiwic3ViIjoie1wiYWNjb3VudFwiOlwienRhYnN0YWZmMVwiLFwidXNlcklkXCI6XCJlYTI5OWUzZjQ5OGY0NDZmOGQ0OGFmMTM5YmRhZDQ2YlwifSIsImV4cCI6MTcyMDU4NDExMywiaWF0IjoxNzIwNTQwOTEzfQ._IV5tBnotmnp40SF2KiJUyA6HIe6v44lzoHTiCsyf4uek8AnSvOHFWmNo1QYPTkavxvoxkW4lISzR8pJ8oykPA'
		return config
	},
	error => {
		// do something with request error
		return Promise.reject(error)
	}
)

// response interceptor
service.interceptors.response.use(
	/**
	 * If you want to get http information such as headers or status
	 * Please return  response => response
	 */

	/**
	 * Determine the request status by custom code
	 * Here is just an example
	 * You can also judge the status by HTTP Status Code
	 */
	response => {
		const res = response.data
		// if the custom code is not 20000, it is judged as an error.
		if (res.code !== 200 && res.code !== 201 && res.code !== 208 && res.code !== 209) {
			Message({
				message: res.message || 'Error',
				type: 'error',
				duration: 5 * 1000
			})

			if (res.code == 700) {
				removeToken()
				// this.$router.push({
				// 	name: 'login'
				// })
				window.location.href = "#/"
			}
			// 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
			if (res.code == 50008 || res.code == 50012 || res.code == 50014) {
				// to re-login
				MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again',
					'Confirm logout', {
						confirmButtonText: 'Re-Login',
						cancelButtonText: 'Cancel',
						type: 'warning'
					}).then(() => {
					removeToken()
					this.$router.push({
						name: 'login'
					})
					// store.dispatch('user/resetToken').then(() => {
					//   location.reload()
					// })
				})
			}
			return Promise.reject(new Error(res.message || 'Error'))
		} else {
			return res
		}
	},
	error => {
		Message({
			message: error.message,
			type: 'error',
			duration: 5 * 1000
		})
		return Promise.reject(error)
	}
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js